import { render, staticRenderFns } from "./HelloWorld.vue?vue&type=template&id=172b4aa8&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"
import style0 from "./HelloWorld.vue?vue&type=style&index=0&id=172b4aa8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172b4aa8",
  null
  
)

export default component.exports